import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";

const HistoryContext = React.createContext({
  state: { historyList: {}, history: {} },
  actions: {
    getHistory: () => {},
    getHistoryList: () => {},
  },
});

const HistoryProvider = ({ children }) => {
  const [history, setHistory] = useState({});
  const [historyList, setHistoryList] = useState([]);

  const getHistory = useCallback((historyId) => {
    HttpAction({
      url: "api/admin/history",
      method: "get",
      params: {
        historyId: historyId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setHistory(res.data);
      } else {
        ErroCode[res.code] && history.push(`/${process.env.REACT_APP_LANGUAGE}/500`);
      }
    });
  }, []);

  const getHistoryList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/history/list",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        historyNoticeTitle: pageInfo && pageInfo.historyNoticeTitle,
        historyYear: pageInfo && pageInfo.historyYear,
        historyMonth: pageInfo && pageInfo.historyMonth,
      },
    }).then((res) => {
      if (res.code === 200) {
        setHistoryList(res.data);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createHistory = useCallback(async (historyData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/history/save`, historyData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updateHistory = useCallback(async (historyData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/history/modify`, historyData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const deleteHistory = useCallback((historyId, history, url) => {
    HttpAction({
      url: "api/admin/history",
      method: "delete",
      params: {
        historyId: historyId,
      },
    }).then((res) => {
      if (res.code === 200) {
        history.push(url);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { history, historyList },
    actions: {
      getHistoryList,
      getHistory,
      createHistory,
      updateHistory,
      deleteHistory,
    },
  };

  return (
    <HistoryContext.Provider value={value}>{children}</HistoryContext.Provider>
  );
};

const { Consumer: HistoryConsumer } = HistoryContext;

export { HistoryProvider, HistoryConsumer, HistoryContext };

export default HistoryContext;
